import React, { PureComponent } from 'react';
import b from 'b_';

import './publications-page-header.css';

import Theme from '@interfaces/themes';
import Themes from '@components/themes-widget';
import PublicationsFilterYear from '@components/publications-year-filter';

interface Props {
    themes: Theme[];
    year?: string | null;
    onThemeChange(themeSlug?: string): void;
    onYearChange(year?: number): void;
}

const class_ = b.with('publications-page-header');

export default class PublicationsPageHeader extends PureComponent<Props> {
    public render() {
        const { themes, year, onYearChange, onThemeChange } = this.props;

        return (
            <div className={class_()}>
                <h1 className="block__title">Publications</h1>

                <Themes
                    items={themes}
                    onThemeClick={onThemeChange}
                />

                <div className={class_('filter')}>
                    <span className={class_('filter-label')}>
                        Latest
                    </span>
                    <PublicationsFilterYear
                        onYearChange={onYearChange}
                        selectedYear={year}
                    />
                </div>
            </div>
        );
    }
}
